<template>
  <!-- Markup mirrors the prototype's `.field > .lbl + input` pattern. Styling
       comes from the compiled registration stylesheet (global, theme-aware via
       CSS custom properties) — see resources/assets/sass/apps/event/shared/registration. -->
  <div class="field" :class="{ 'field--flush': flush }">
    <label v-if="label" class="lbl" :for="inputId">
      {{ label }}<span v-if="requiredMark" aria-hidden="true"> *</span>
    </label>
    <input
      :id="inputId"
      ref="input"
      v-bind="$attrs"
      :type="type"
      :value="value"
      :placeholder="placeholder"
      :class="{ 'is-invalid': !!error }"
      :aria-invalid="!!error || null"
      @input="$emit('input', $event.target.value)"
      @blur="$emit('blur', $event.target.value)"
      @change="$emit('change', $event.target.value)"
      @focus="$emit('focus', $event)"
    />
    <div v-if="error" class="field-error">{{ error }}</div>
  </div>
</template>

<script>
let uid = 0

export default {
  name: 'lp-input',
  inheritAttrs: false,
  props: {
    value: { type: [String, Number, null], default: '' },
    type: { type: String, default: 'text' },
    label: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    error: { type: String, default: '' },
    requiredMark: { type: Boolean, default: false },
    // Drop the bottom margin (e.g. inside `.form-grid-*`).
    flush: { type: Boolean, default: false },
    id: { type: String, default: '' },
  },
  data() {
    return { autoId: `lp-input-${++uid}` }
  },
  computed: {
    inputId() { return this.id || this.autoId },
  },
  methods: {
    focus() { if (this.$refs.input) this.$refs.input.focus() },
  },
}
</script>

<style lang="scss">
input[type=text], input[type=email], input[type=tel], select, textarea {
  width: 100%;
  padding: 10px 12px;
  border: 0.5px solid var(--border-strong);
  border-radius: var(--radius-sm);
  font-size: var(--fs-body);
  background: var(--surface);
  font-family: inherit;
  color: var(--text);
  transition: border-color 0.1s, box-shadow 0.1s;
}
input:focus, select:focus, textarea:focus {
  outline: none;
  border-color: var(--brand);
  box-shadow: 0 0 0 3px var(--brand-soft);
}
input[type=checkbox], input[type=radio] { accent-color: var(--brand); cursor: pointer; }

.lbl {
  display: block;
  font-size: var(--fs-label);
  color: var(--text-secondary);
  margin-bottom: 5px;
  font-weight: 500;
}
.field { margin-bottom: 16px; }
.field--flush { margin-bottom: 0; }
.field-error {
  color: var(--danger);
  font-size: var(--fs-label);
  margin-top: 5px;
  line-height: 1.4;
}
input.is-invalid,
select.is-invalid,
textarea.is-invalid {
  border-color: var(--danger);
}
input.is-invalid:focus,
select.is-invalid:focus,
textarea.is-invalid:focus {
  border-color: var(--danger);
  box-shadow: 0 0 0 3px rgba(192, 57, 43, 0.16);
}
</style>
